import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCashes(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/cashes', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCash(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/cashes/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createCash(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/cashes/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addCash(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/cashes`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteCash(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/cashes/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editCash(ctx, { id }){
            return new Promise((resolve, reject) => {
                axios
                    .get(`/cashes/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateCash(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/cashes/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}